<template>
  <div class="progress-container" :style="containerStyle">
    <div
      class="progress-bar"
      :style="{
        width: `${currentPercentage}%`,
        backgroundColor: filledColor,
      }"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      default: 0,
      validator: (val: number) => val >= 0 && val <= 100,
    },
    height: {
      type: Number,
      default: 12,
    },
    filledColor: {
      type: String,
      default: '#492B7C',
    },
    unfilledColor: {
      type: String,
      default: '#FAFAFA',
    },
  },
  setup(props) {
    const currentPercentage = computed(() =>
      Math.min(100, Math.max(0, props.percentage)),
    );

    const containerStyle = computed(() => ({
      height: `${props.height}px`,
      backgroundColor: props.unfilledColor,
    }));

    return {
      currentPercentage,
      containerStyle,
    };
  },
});
</script>

<style scoped>
.progress-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  border-radius: 8px;
  transition: width 0.3s ease-in-out;
}
</style>
